import React, { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Text,
  FormControl,
  FormLabel,
  Input,
  Flex,
  SimpleGrid,
  Select,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { getData } from '../../utils/httpClient';

export default function CreatetModal({
  isOpen,
  onClose,
  formData,
  setFormData,
  onConfirm,
  title,
}) {
  const [studyList, setStudyList] = useState([]);

  const toast = useToast();

  const getStudyList = async () => {
    try {
      const response = await getData('/study');
      setStudyList(response?.payload?.studies || []);
    } catch (error) {
      toast({
        title: 'Error al cargar los estudios.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getStudyList();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        maxWidth={{ base: '100%', md: '80%' }}
        minHeight={'85vh'}
        maxHeight={'85vh'}
        overflowY="auto"
      >
        <ModalHeader mb={5}>{title || 'Agregar plan de estudio'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
            align="center"
          >
            <Box flex="1" mb={5}>
              <SimpleGrid columns={{ base: 1 }} spacing={5} mt={4}>
                {/* Description */}
                <FormControl id="name" isRequired>
                  <FormLabel>Nombre</FormLabel>
                  <Input
                    placeholder="Descripción"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </FormControl>

                {/* Study Type */}
                <FormControl id="studyId" isRequired>
                  <FormLabel>Estudio</FormLabel>
                  <Select
                    name="studyTypeId"
                    value={formData.studyId || ''}
                    onChange={handleInputChange}
                  >
                    <option value="">Seleccione</option>
                    {studyList.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.description}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {/* Study Plan Date */}
                <FormControl id="startDate" isRequired>
                  <FormLabel>Fecha de vigencia</FormLabel>
                  <Input
                    type="date"
                    name="startDate"
                    value={formData.startDate || ''}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </SimpleGrid>
            </Box>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Box>
            <Button
              colorScheme="blue"
              onClick={onConfirm}
              width="120px" // Fija el tamaño del botón
            >
              Completar
            </Button>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
